import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

const GroupHeadAllDealsModal = React.memo(({
    show,
    onHide,
    item,
    departmentTitle,
    additionalHeaderContent,
    tableHeaders,
    renderProjectRow
}) => {
    const { GroupHeadName, Projects = [] } = item || {};

    return (
        <div>
            <Modal
                show={show}
                onHide={onHide}
                contentClassName="dashboard-modal-styles"
                dialogClassName="dashboard-modal"
                scrollable={true}
                data-testid="modal"
            >
                <Modal.Header
                    className="dashboard-modal-header"
                    closeButton
                    data-testid="modal-header"
                >
                    <Modal.Title className="dashboard-modal-title ml-4" data-testid="modal-title">
                        {GroupHeadName} {additionalHeaderContent && `(${additionalHeaderContent})`}
                        <p className="subDepartmentTitle">{departmentTitle}</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="techModalBody" data-testid="modal-body">
                    <table className="TechDashboard" data-testid="project-table">
                        <thead className="MemberTableColumnHeader techHeader">
                            <tr className="tableColumnTitles tableHeader">
                                {tableHeaders.map((header) => (
                                    <th key={header} className="col-md-1 col-sm-1 textEllipsis headerSorted">{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="tableBody techBody">
                            {Projects.map((project) => renderProjectRow(project))}
                        </tbody>
                    </table>
                </Modal.Body>
            </Modal>
        </div>
    );
});

GroupHeadAllDealsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    item: PropTypes.shape({
        GroupHeadName: PropTypes.string,
        Projects: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
    departmentTitle: PropTypes.string.isRequired,
    additionalHeaderContent: PropTypes.string,
    tableHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
    renderProjectRow: PropTypes.func.isRequired
};

export default GroupHeadAllDealsModal;
